import { Dict } from './../../node_modules/@types/mixpanel-browser/index.d';
import mixpanel from 'mixpanel-browser';

export function useMixPanel() {
    const track = (eventName: string, properties?: Dict) =>
        mixpanel.track(eventName, properties);

    return { track };
}
